import apiClient from '../../../api-client';

export interface CompanyConfiguration {
  id: number;
  company_id: number;
  option: string;
  option_value: boolean;
  domain?: string;
}

export class ConfigurationService {
  public async getCompanyConfigurations(companyId: number) {
    try {
      const response = await apiClient.get(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/company/${companyId}/configurations`
      );
      return response.data;
    } catch (error: any) {
      throw new Error(
        `Error fetching company configurations: ${
          error.response?.statusText || error.message
        }`
      );
    }
  }

  public async createCompanyConfiguration(
    companyId: number,
    config: Omit<CompanyConfiguration, 'id'>
  ) {
    try {
      const response = await apiClient.post(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/company/${companyId}/configurations`,
        config
      );
      return response.data;
    } catch (error: any) {
      throw new Error(
        `Error creating company configuration: ${
          error.response?.statusText || error.message
        }`
      );
    }
  }

  public async updateCompanyConfiguration(
    configId: number,
    companyId: number,
    updates: Partial<Omit<CompanyConfiguration, 'id'>>
  ) {
    try {
      const response = await fetch(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/company/${companyId}/configurations/${configId}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        }
      );

      if (!response.ok) {
        throw new Error(
          `Error updating company configuration: ${response.statusText}`
        );
      }

      return await response.json();
    } catch (error: any) {
      throw new Error(
        `Error updating company configuration: ${
          error.response?.statusText || error.message
        }`
      );
    }
  }
}
